import { render } from "./Account.vue?vue&type=template&id=34c1bffb"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"

import "./Account.vue?vue&type=style&index=0&id=34c1bffb&lang=css"
script.render = render

export default script